import { z } from 'zod';

export const ExerciseMaxConversionFormSchema = z
  .object({
    fromLibraryExerciseId: z.string(),
    toLibraryExerciseId: z.string(),
    percentage: z.number().int().positive().max(200),
  })
  .refine(
    ({ fromLibraryExerciseId, toLibraryExerciseId }) =>
      fromLibraryExerciseId !== toLibraryExerciseId,
    {
      message: 'Exercise and target exercise cannot be the same',
      path: ['toLibraryExerciseId'],
    },
  );
export type ExerciseMaxConversionFormType = z.infer<
  typeof ExerciseMaxConversionFormSchema
>;

export function ratioToPercentage(ratio: number) {
  return Math.round(ratio * 100);
}

export function ratioFromPercentage(percentage: number) {
  return percentage / 100;
}
